import { memo, useState } from "react";
import { Layout, Drawer } from "antd";
import PropTypes from "prop-types";
import { useViewportSize } from "hooks";

import { VIEW_PORT_SIZE } from "utils/constants";
import NavBar from "./Navbar";
import SideMenu from "./SideMenu";
import ChatPopup from "components/ChatPopup";
import "./styles.less";

const DashboardLayout = ({
  collapseMenu,
  toggleCollapseMenu,
  currentUser,
  menu,
  children,
}) => {
  const size = useViewportSize();
  const isDesktopViewport = size.width > VIEW_PORT_SIZE.TABLET;
  const [collapsed, setCollapsed] = useState(false);

  const handleToggleCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  const siderWidth = collapsed ? 80 : 256;

  return (
    <Layout className="layout" style={{ minHeight: "100vh" }}>
      {isDesktopViewport ? (
        <SideMenu collapsed={collapsed} width={256} />
      ) : (
        <Drawer
          placement="left"
          closable={false}
          onClose={() => toggleCollapseMenu(false)}
          bodyStyle={{ padding: 0 }}
          open={collapseMenu}
          visible={collapseMenu}
          key="left"
          width={260}
          destroyOnClose
          className="mobile-menu-drawer"
        >
          <SideMenu collapsed={false} />
        </Drawer>
      )}
      <Layout style={isDesktopViewport ? { marginLeft: siderWidth, transition: "margin-left 0.2s" } : undefined}>
        <NavBar
          collapsed={collapsed}
          toggleCollapse={handleToggleCollapse}
          toggleCollapseMenu={toggleCollapseMenu}
          menu={menu}
          currentUser={currentUser}
          isDesktopViewport={isDesktopViewport}
        />
        <div className="layout-content">{children}</div>
        <ChatPopup />
      </Layout>
    </Layout>
  );
};

DashboardLayout.propTypes = {
  collapseMenu: PropTypes.bool,
  toggleCollapseMenu: PropTypes.func,
  children: PropTypes.any,
  currentUser: PropTypes.object,
  menu: PropTypes.func,
};
export default memo(DashboardLayout);
